(function session() {
    'use strict';

    let expirationWarning;
    let sessionExpired;
    let sessionModal;
    let isLoggedInCustomer = false;

    /**
     * @function showExpiredModal
     *
     * @description
     * Opens expired modal
     */
    function showExpiredModal() {
        window.bs.Modal.getInstance(sessionModal)?.hide();
        sessionModal = document.getElementById('session-modal-expired');
        sessionModal?.render();
    }

    /**
     * @function onClick
     *
     * @description
     * To ensure the session won't expire, a call to login page is made. This
     * call will refresh the latest session and resets the timeouts.
     */
    function onClick() {
        fetch(window.urls.loginShow).then((res) => {
            // if no redirect has happened for logged in customer that means session has expired
            if (!res.redirected && isLoggedInCustomer) {
                showExpiredModal();
            }
        });
        clearTimeout(expirationWarning);
        clearTimeout(sessionExpired);
        setTimeouts(); // eslint-disable-line
        document.removeEventListener('click', onClick);
    }

    /**
     * @function hideAllModals
     *
     * @description
     * Will hide all active modals
     */
    function hideAllModals() {
        const activeModals = [...document.querySelectorAll('.modal.show')];

        activeModals.forEach((modal) => {
            window.bs.Modal.getInstance(modal).hide();
        });
    }

    /**
     * @function showSessionModal
     *
     * @description
     * Creates a new modal and show it. The modal will be closed by clicking anywhere
     * on the page and triggers the onClick method.
     */
    function showSessionModal() {
        hideAllModals();
        document.addEventListener('click', onClick);
        sessionModal = document.getElementById('session-modal');
        sessionModal?.render();
    }

    /**
     * @function setTimeouts
     *
     * @description
     * Every 30 minutes users session will expire when inactive. After 15
     * minutes a warning modal will be shown to inform the user about inactivity.
     * When the 30 minutes passed, the user will be redirected to the Cart page.
     */
    function setTimeouts() {
        const warningTimeoutDuration = 1000 * 60 * 15; // 15 minutes
        const expiredTimeoutDuration = 1000 * 60 * 30; // 30 minutes
        expirationWarning = setTimeout(showSessionModal, warningTimeoutDuration);
        sessionExpired = setTimeout(showExpiredModal, expiredTimeoutDuration);
    }

    /**
     * @function checkCustomerStatus
     *
     * @description
     * Checks the status of the customer.
     * Makes a fetch request to the Login URL and determines if the user is logged in.
     * Runs setTimeouts after updating customer's status
     */
    function checkCustomerStatus() {
        fetch(window.urls.loginShow)
            .then((res) => {
                // if redirect has happened that means the user is logged in
                isLoggedInCustomer = res.redirected;
            })
            .then(setTimeouts);
    }

    // Kick off!
    checkCustomerStatus();
})();
